var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',_vm._b({attrs:{"headers":_vm.headers,"items":_vm.items,"mobile-breakpoint":"768","hide-default-footer":""}},'v-data-table',_vm.$attrs,false))
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }